<aside
    class ="agpr-mentionDetailsTakeoverPanel-overlay"
    [ngStyle]="{'z-index': zIndex}"
    (clickOutside)="closeDialog()"
    [clickOutsideEnabled]="false"
    exclude=".agpr-clickOutsideExcluded"
    [excludeBeforeClick]="true"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [@slideInOutAnimation]="slideInOutAnimation"
    (@slideInOutAnimation.done)="animationDone($event)"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="agpr-mentionDetailsTakeoverPanel-greyout"
        (click)="closeDialog()"
    >
        <agpr-button
            class="agpr-mentionDetailsTakeoverPanel-focusClose"
            [style]="buttonTypes.icon"
            icon="agpr-i-close"
            tooltip="close"
            tooltipPosition="top"
            (click)="closeDialog()"
        ></agpr-button>
    </div>
    <div class="agpr-mentionDetailsTakeoverPanel-mentionContent">
        <agpr-scroll-panel #mentionScrollPanel>
            <h3 class="agpr-mentionDetailsTakeoverPanel-header">{{'Mention.workbench.insights.RHP.mentionView.mention' | localize}}</h3>
            <agpr-mention-content
                [id]="'monitoringResult'"
                [highlightKeywords]="highlightKeywords"
                [showImageList]="!!focusedMention"
                [isTakeOverPanel]="true"
                [isLanguagePanelHalfWidth]="true"
                [showOriginalImageSize]="true"
                (outletClicked)="focusOutletTab()"
                (contactClicked)="focusContactTab()"
            ></agpr-mention-content>
        </agpr-scroll-panel>
        <div class="agpr-mentionDetailsTakeoverPanel-navigator">
            <div class="agpr-mentionDetailsTakeoverPanel-navigatorContainer">
                <agpr-button
                    [id]="'mention_details_takeover_previousMention'"
                    class="agpr-mentionDetailsTakeoverPanel-navigatorButtons agpr-mentionDetailsTakeoverPanel-navigatorButtons--previous"
                    [style]="buttonTypes.tertiary"
                    [label]="'Mention.details.navigator.previousMention' | localize"
                    [icon]="'fa-solid fa-angle-left'"
                    [disabled]="isFirstMention"
                    (click)="onPrevious()">
                </agpr-button>

                <agpr-button
                    [id]="'mention_details_takeover_nextMention'"
                    class="agpr-mentionDetailsTakeoverPanel-navigatorButtons agpr-mentionDetailsTakeoverPanel-navigatorButtons--next"
                    [style]="buttonTypes.tertiary"
                    [label]="'Mention.details.navigator.nextMention' | localize"
                    [tailIcon]="'fa-solid fa-angle-right'"
                    [disabled]="isLastMention"
                    (click)="onNext()">
                </agpr-button>
            </div>
        </div>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <aside
        class="agpr-mentionDetailsTakeoverPanel-sidebar"
    >
        @if((selectedTabIndex === mentionDetailsTabEnum.contact && focusedMention?.author?.uuid)
            || (selectedTabIndex === mentionDetailsTabEnum.outlet && (focusedMention?.publication?.uuid || focusedMention?.author?.uuid))) {
            <button
                class="agpr-mentionDetailsTakeoverPanel-contentToggle"
                (click)="expandClicked()"
                [attr.aria-label]="'Discover.entityProfile.expand' | localize"
                [agprTooltip]="'Discover.entityProfile.expand'"
            >
                <span
                    class="fa-solid fa-circle-chevron-left agpr-mentionDetailsTakeoverPanel-contentToggle-toggleIcon"
                    aria-hidden="true"
                ></span>
            </button>
        }
        <agpr-right-sidebar
            #rhpTabs
            [loading]="isLoading"
            [(selectedTabIndex)]="selectedTabIndex"
        >
            <agpr-tab
                [id]="'monitoringMention'"
                icon=" fa-file"
                tooltip="Mention.details.mentionInformation"
            >
                <agpr-mention-details
                    [id]="'monitoringResult'"
                    [highlightKeywords]="highlightKeywords"
                    [hasProminenceProvision]="true"
                    [isDetailsTakeOverPanel]="true"
                    [showInsights]="focusedMention && !!focusedMention.mentionId"
                ></agpr-mention-details>
                <ng-template #tabFooter>
                    <agpr-action-bar *ngIf="focusedMention && focusedMention.mentionId">
                        <ng-template #right>
                            <agpr-button
                                label="Monitoring.result.editMention"
                                [style]="buttonTypes.tertiary"
                                id="monitoringResult.editMention"
                                (click)="editSelectedMention()"
                            ></agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </ng-template>
            </agpr-tab>
            <agpr-entity-details-tab
                #contactProfileTab
                [id]="'monitoringRhpTab.contactProfile'"
                icon="fa-regular fa-duotone fa-user"
                tooltip="Discover.targeting.rhp.tabs.profileMeta"
                [entityType]="entityTypes.CONTACT"
                [syncOutletTabInfo]="false"
                [noContactMessage]="focusedMention?.author.name ? 'Monitor.entityProfile.noAdditionalInfo' : 'Monitor.entityProfile.noContact'"
                [fullHeightProfileTakeover]="fromReports"
                (loading)="isLoading = $event"
            ></agpr-entity-details-tab>
            <agpr-entity-details-tab
                #outletProfileTab
                [id]="'monitoringRhpTab.outletProfile'"
                icon="fa-kit-duotone fa-agpr-outlet"
                tooltip="Discover.targeting.rhp.tabs.outletProfileMeta"
                [entityType]="entityTypes.OUTLET"
                [noOutletMessage]="focusedMention?.publication.name ? 'Monitor.entityProfile.noAdditionalInfo' : 'Monitor.entityProfile.noOutlet' "
                [fullHeightProfileTakeover]="fromReports"
                (loading)="isLoading = $event"
            ></agpr-entity-details-tab>
            <agpr-mention-insights-explorer-tab
                *ngIf="mieEnabled"
                [id]="'mentionInsightsExplorerTab'"
                icon="fa-kit-duotone fa-agpr-insights"
                tooltip="Monitoring.results.rhp.mentionInsightExplorer"
            ></agpr-mention-insights-explorer-tab>
        </agpr-right-sidebar>
    </aside>
</aside>
